import { render } from "./ProjectModal.vue?vue&type=template&id=c99fc6e4&scoped=true"
import script from "./ProjectModal.vue?vue&type=script&lang=js"
export * from "./ProjectModal.vue?vue&type=script&lang=js"

import "./ProjectModal.vue?vue&type=style&index=0&id=c99fc6e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c99fc6e4"]])

export default __exports__